import { useCallback, useEffect, useState } from 'react'
import { useAddAssociatedWalletMutation } from '../../graphql/generated/graphql'
import { useConnectedWallet } from '../ConnectedWalletProvider'
import { getWalletType } from '../connection/utils'
import { useWeb3Connection } from '../Web3Provider'

export const useDisconnectWallet = () => {
    const { removeConnectedWallet } = useConnectedWallet()
    const { connector, account } = useWeb3Connection()
    return useCallback(() => {
        const walletType = getWalletType(connector)
        if (connector.deactivate) {
            connector.deactivate()
        } else {
            connector.resetState()
        }
        if (account) removeConnectedWallet({ account, walletType })
    }, [account, connector, removeConnectedWallet])
}

export const useWalletActivated = () => {
    const { addConnectedWallet, connectedWallets } = useConnectedWallet()
    const { connector, account, chainId } = useWeb3Connection()
    const [addWalletMutation] = useAddAssociatedWalletMutation()
    const [lastActiveWalletAddress, setLastActiveWalletAddress] = useState<string | undefined>(
        account
    )
    useEffect(() => {
        if (account) {
            addWalletMutation({ variables: { address: account } })
        }

        if (account && account !== lastActiveWalletAddress) {
            const walletType = getWalletType(connector)
            const isReconnect =
                connectedWallets.filter(
                    (wallet) => wallet.account === account && wallet.walletType === walletType
                ).length > 0
            if (!isReconnect) {
                addConnectedWallet({ account, walletType })
            }
        }
        setLastActiveWalletAddress(account)
    }, [
        connectedWallets,
        addConnectedWallet,
        lastActiveWalletAddress,
        account,
        connector,
        chainId,
        addWalletMutation,
    ])
}
